export const config = {
  projectId: 'o8d0sazo',
  dataset: 'production',
  token: process.env.SANITY_AUTH_TOKEN, // or leave blank to be anonymous user
  apiVersion: '2021-06-09',
  useCdn: false, // `false` if you want to ensure fresh data
};
